import client from '../client'

export const markAsSeenKey = `${process.env.NEXT_PUBLIC_NOTIFICATIONS_DOMAIN}/api/UserNotifications/MarkAsSeen`

export async function markAsSeen({ vehicleId }) {
  return client(markAsSeenKey, {
    headers: { 'Content-Type': 'application/json' },
    method: 'POST',
    body: JSON.stringify({ vehicleId }),
  })
}
